module.exports = __webpack_public_path__ + "img/banner_privacy_portal.cb4baa12.webp";